"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var Input_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Input"));

var Modal_1 = tslib_1.__importStar(require("@sportnet/ui/lib/Modal"));

var Paginator_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Paginator"));

var Segment_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Segment"));

var Table_1 = require("@sportnet/ui/lib/Table");

var utilities_1 = require("@sportnet/ui/lib/utilities");

var react_1 = tslib_1.__importDefault(require("react"));

var sportnet_utilities_1 = require("sportnet-utilities");

var detail_1 = tslib_1.__importDefault(require("./detail"));

var DEFAULT_LIST_LIMIT = 50;

var OrganizationProfilesList = function (props) {
  var _a = props.data,
      data = _a === void 0 ? {} : _a,
      renderEmpty = props.renderEmpty;

  var _b = react_1["default"].useState([]),
      organizationProfiles = _b[0],
      setOrganizationProfiles = _b[1];

  var _c = react_1["default"].useState(0),
      total = _c[0],
      setTotal = _c[1];

  var _d = react_1["default"].useState(0),
      currentOffset = _d[0],
      setCurrentOffset = _d[1];

  var _e = react_1["default"].useState(false),
      isFetching = _e[0],
      setIsFetching = _e[1];

  var _f = react_1["default"].useState(''),
      q = _f[0],
      setQ = _f[1];

  var _g = react_1["default"].useState(0),
      offset = _g[0],
      setOffset = _g[1];

  var _h = react_1["default"].useState(DEFAULT_LIST_LIMIT),
      limit = _h[0],
      setLimit = _h[1];

  var _j = react_1["default"].useState(null),
      activeProfileId = _j[0],
      setActiveProfileId = _j[1];

  react_1["default"].useEffect(function () {
    var hasHashItem = (window.location.hash || '').includes('#profileId=');

    if (hasHashItem) {
      var id = (window.location.hash || '').replace('#profileId=', '');

      if (id) {
        setActiveProfileId(id);
      }
    }

    setOrganizationProfiles(sportnet_utilities_1.getProp(data, ['data', 'items'], []));
    setLimit(sportnet_utilities_1.getProp(data, ['filters', 'limit'], DEFAULT_LIST_LIMIT));
  }, []);

  var toggleProfileModal = function (id) {
    if (id === void 0) {
      id = null;
    }

    if (history.pushState) {
      history.pushState(null, '', id ? "#profileId=" + id : "" + location.pathname + location.search);
    } else {
      location.hash = id ? "#profileId=" + id : '';
    }

    setActiveProfileId(id);
  };

  var setQuery = react_1["default"].useMemo(function () {
    return utilities_1.debounce(function (e) {
      setCurrentOffset(0);
      setQ(e);
    }, 0);
  }, []);
  var offsetedItems = organizationProfiles.sort(function (a, b) {
    return (a.name || '') > (b.name || '') ? 1 : -1;
  });

  if (q) {
    offsetedItems = offsetedItems.filter(function (i) {
      var regexp = new RegExp(q, 'i');
      return sportnet_utilities_1.removeAccents(i.name || '').match(regexp);
    });
  }

  var offsetedTotal = offsetedItems.length;
  offsetedItems = offsetedItems.slice(currentOffset, currentOffset + limit);
  return react_1["default"].createElement(Segment_1["default"], {
    raised: true
  }, react_1["default"].createElement(Input_1["default"], {
    onChange: function (e) {
      setQuery(e.target.value);
    },
    placeholder: utilities_1.__('Zadajte názov...')
  }, react_1["default"].createElement(Input_1["default"].Icon, {
    name: "search"
  }), react_1["default"].createElement("input", null)), react_1["default"].createElement("br", null), react_1["default"].createElement(Table_1.Table, null, react_1["default"].createElement(Table_1.Thead, null, react_1["default"].createElement(Table_1.Tr, null, react_1["default"].createElement(Table_1.Th, null, utilities_1.__('Názov')))), react_1["default"].createElement(Table_1.Tbody, null, offsetedItems.map(function (u) {
    return react_1["default"].createElement(Table_1.Tr, {
      key: u._id,
      onClick: function () {
        toggleProfileModal(u._id);
      }
    }, react_1["default"].createElement(Table_1.Td, null, u.name));
  }))), react_1["default"].createElement(Paginator_1["default"], {
    total: offsetedTotal,
    offset: currentOffset,
    loading: isFetching,
    onChangeOffset: function (newOffset) {
      setCurrentOffset(newOffset);
    },
    limit: limit
  }), !!activeProfileId && react_1["default"].createElement(Modal_1["default"], {
    handleClose: function () {
      return toggleProfileModal();
    },
    isOpen: !!activeProfileId
  }, react_1["default"].createElement(Modal_1.ModalContent, null, activeProfileId && react_1["default"].createElement(detail_1["default"], {
    id: activeProfileId,
    handleClose: toggleProfileModal
  }))));
};

exports["default"] = OrganizationProfilesList;